import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { MeterProvider, PeriodicExportingMetricReader, } from '@opentelemetry/sdk-metrics';
let globalMeterProvider;
export const initMetrics = (serviceName, metricConfig) => {
    if (globalMeterProvider) {
        console.error('MeterProvider already initialized');
        return;
    }
    const metricExporter = new OTLPMetricExporter({
        url: metricConfig.url,
    });
    globalMeterProvider = new MeterProvider({
        readers: [
            new PeriodicExportingMetricReader({
                exporter: metricExporter,
                exportIntervalMillis: metricConfig.flushConfig.flushIntervalMs,
            }),
        ],
        resource: resourceFromAttributes({
            'service.name': serviceName,
        }),
    });
};
export const getMeter = (name, version, options) => {
    if (!globalMeterProvider) {
        throw new Error('MeterProvider not initialized');
    }
    return globalMeterProvider.getMeter(name, version, options);
};
//# sourceMappingURL=metrics.js.map